import React from "react";

import svg from "../../assets/images/icons/Form Controls/Radio Button Group.svg";

export const RadioListIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Radio Group"}
    />
);
